import React from "react";
import { Helmet } from "react-helmet";

function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta
          name="description"
          content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς."
        />
      </Helmet>

      <div className="policy-container">
        <h1>Πολιτική Επιστροφών και Επιστροφής Χρημάτων</h1>
        <p className="policy-updated">
          Τελευταία ενημέρωση: 15 Ιανουαρίου 2025
        </p>

        <section className="policy-section">
          <h2>1. Εγγύηση Ικανοποίησης</h2>
          <p>
            Στο Sororin, στοχεύουμε στην πλήρη ικανοποίηση των πελατών μας. Εάν
            δεν είστε ευχαριστημένοι με την αγορά σας για οποιονδήποτε λόγο,
            μπορείτε να επιστρέψετε το προϊόν εντός 30 ημερών από την ημερομηνία
            παράδοσης για πλήρη επιστροφή χρημάτων ή ανταλλαγή.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Προϋποθέσεις Επιστροφής</h2>
          <p>Για να είναι επιλέξιμο ένα προϊόν για επιστροφή, πρέπει:</p>
          <ul>
            <li>Να είναι στην αρχική του κατάσταση και συσκευασία</li>
            <li>Να είναι αχρησιμοποίητο και σε άριστη κατάσταση</li>
            <li>Να συνοδεύεται από την απόδειξη αγοράς</li>
            <li>Να επιστραφεί εντός 30 ημερών από την ημερομηνία παράδοσης</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Προϊόντα που δεν Επιστρέφονται</h2>
          <p>
            Για λόγους υγιεινής και ασφάλειας, τα ακόλουθα προϊόντα δεν μπορούν
            να επιστραφούν:
          </p>
          <ul>
            <li>Προϊόντα που έχουν ανοιχτεί ή χρησιμοποιηθεί</li>
            <li>Προϊόντα χωρίς την αρχική τους σφραγίδα ασφαλείας</li>
            <li>Προϊόντα που αγοράστηκαν με έκπτωση άνω του 50 τοις εκατό</li>
            <li>Προσαρμοσμένα ή εξατομικευμένα προϊόντα</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Διαδικασία Επιστροφής</h2>
          <h3>Βήμα 1: Επικοινωνήστε μαζί μας</h3>
          <p>
            Επικοινωνήστε με την ομάδα εξυπηρέτησης πελατών μας στο{" "}
            <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a> ή στο
            +302394023553 για να ξεκινήσετε τη διαδικασία επιστροφής.
          </p>

          <h3>Βήμα 2: Λάβετε Εξουσιοδότηση</h3>
          <p>
            Θα σας παρέχουμε έναν αριθμό εξουσιοδότησης επιστροφής και οδηγίες
            για την επιστροφή του προϊόντος.
          </p>

          <h3>Βήμα 3: Αποστείλετε το Προϊόν</h3>
          <p>
            Συσκευάστε το προϊόν με ασφάλεια και αποστείλτε το στη διεύθυνσή
            μας. Συνιστούμε να χρησιμοποιήσετε μια υπηρεσία αποστολής με
            δυνατότητα παρακολούθησης.
          </p>

          <h3>Βήμα 4: Επιστροφή Χρημάτων</h3>
          <p>
            Μόλις λάβουμε και ελέγξουμε το επιστρεφόμενο προϊόν, θα
            επεξεργαστούμε την επιστροφή χρημάτων εντός 5-7 εργάσιμων ημερών.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Έξοδα Επιστροφής</h2>
          <p>
            Τα έξοδα αποστολής επιστροφής βαρύνουν τον πελάτη, εκτός εάν η
            επιστροφή οφείλεται σε σφάλμα από την πλευρά μας ή ελαττωματικό
            προϊόν. Σε αυτές τις περιπτώσεις, θα καλύψουμε τα πλήρη έξοδα
            επιστροφής.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Ανταλλαγές</h2>
          <p>
            Εάν θέλετε να ανταλλάξετε ένα προϊόν με κάτι διαφορετικό,
            επικοινωνήστε μαζί μας και θα σας βοηθήσουμε. Οι ανταλλαγές
            υπόκεινται στους ίδιους όρους με τις επιστροφές.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Ελαττωματικά Προϊόντα</h2>
          <p>
            Εάν λάβετε ένα ελαττωματικό προϊόν, επικοινωνήστε μαζί μας αμέσως.
            Θα σας παρέχουμε αντικατάσταση ή πλήρη επιστροφή χρημάτων,
            συμπεριλαμβανομένων των εξόδων αποστολής.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. Καθυστερημένες ή Χαμένες Παραδόσεις</h2>
          <p>
            Εάν η παραγγελία σας δεν έχει φτάσει εντός του αναμενόμενου χρονικού
            πλαισίου παράδοσης, επικοινωνήστε μαζί μας αμέσως. Θα διερευνήσουμε
            το ζήτημα και θα παρέχουμε λύση, είτε με την αποστολή νέας
            παραγγελίας είτε με πλήρη επιστροφή χρημάτων.
          </p>
        </section>

        <section className="policy-section">
          <h2>9. Επιστροφή Χρημάτων</h2>
          <p>
            Οι επιστροφές χρημάτων θα πιστωθούν στην ίδια μέθοδο πληρωμής που
            χρησιμοποιήθηκε για την αρχική αγορά. Ο χρόνος επεξεργασίας
            εξαρτάται από την τράπεζα ή τον πάροχο πληρωμών σας, αλλά συνήθως
            διαρκεί 5-10 εργάσιμες ημέρες.
          </p>
        </section>

        <section className="policy-section">
          <h2>10. Ακύρωση Παραγγελίας</h2>
          <p>
            Μπορείτε να ακυρώσετε την παραγγελία σας ανά πάσα στιγμή πριν
            αποσταλεί. Αφού αποσταλεί η παραγγελία, πρέπει να ακολουθήσετε τη
            συνήθη διαδικασία επιστροφής.
          </p>
        </section>

        <section className="policy-section">
          <h2>11. Επικοινωνία</h2>
          <p>
            Για οποιεσδήποτε ερωτήσεις σχετικά με την πολιτική επιστροφών μας,
            παρακαλούμε επικοινωνήστε μαζί μας:
          </p>
          <p>
            Email: <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a>
            <br />
            Τηλέφωνο: +302394023553
            <br />
            Διεύθυνση: Λεωφόρος Βενιζέλος, 2, 898 60, Λαγκαδάς, Greece
            <br />
            Ώρες λειτουργίας: Δευτέρα - Παρασκευή, 09:00 - 18:00
          </p>
        </section>
      </div>
    </>
  );
}

export default RefundPolicy;
